import * as React from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilter, faWrench, faGlobe } from "@fortawesome/free-solid-svg-icons"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import ContactBanner from "../../components/ContactBanner"
import onlineDeposits from "../../assets/images/online-deposits.jpg"
import reserveVehicleWidget from "../../assets/images/reserve-vehicle-widget.jpg"
import PCI from "../../assets/images/pci.svg"
import Feature from "../../components/Feature"

export default () => (
  <Layout fixedHeader={false}>
    <SEO title="Online Automotive Deposits" />
    <div className="container mb-4">
      <div className="heading">
        <h1>Online Automotive Deposits</h1>
        <h4 className="secondary">
          Our Online Deposits software enables your website visitors to secure
          vehicles on-demand.
        </h4>
      </div>
      <Feature>
        <div className="text-image">
          <LazyLoadImage
            src={reserveVehicleWidget}
            alt="Online Automotive Reservations"
            className="media"
          />
          <div className="content">
            <h2>Start Dealing 24/7</h2>
            <p>
              The average dealer website has hundreds if not thousands of
              visitors in a single day. Many of these visitors will be browsing
              out of business hours.
            </p>
            <p>
              Online Deposits enables you to take deposits on vehicles 24/7
              directly from your website. The on-demand economy continues to
              grow and many customers expect to be able to secure a vehicle
              instantly.
            </p>
          </div>
        </div>
        <div className="badges">
          <div className="badge">
            <div className="icon blue">
              <FontAwesomeIcon icon={faFilter} />
            </div>
            <span>Designed to convert</span>
          </div>
          <div className="badge">
            <div className="icon purple">
              <FontAwesomeIcon icon={faWrench} />
            </div>
            <span>Customisable</span>
          </div>
          <div className="badge">
            <img src={PCI} alt="PCI" />
            <span>PCI compliant</span>
          </div>
          <div className="badge">
            <div className="icon dark-blue">
              <FontAwesomeIcon icon={faGlobe} />
            </div>
            <span>Works on all websites</span>
          </div>
        </div>
      </Feature>
      <Feature>
        <div className="text-image">
          <div className="content">
            <h2>Seamless Integration</h2>
            <p>
              Online Deposits seamlessly integrates with your website like never
              before. Many other reservation/buy now solutions on the market are
              cumbersome and cost you sales. We make it easier than ever for
              visitors to leave a deposit without leaving your website.
            </p>
          </div>
          <LazyLoadImage
            src={onlineDeposits}
            alt="Online Automotive Deposits"
            className="media"
          />
        </div>
      </Feature>
    </div>
    <ContactBanner />
  </Layout>
)
